module.exports = __webpack_public_path__ + "media/components/breakheader/static/icon--s3-1fe2a002962d0ab4ccc72dfbe6359e4e.svg";